import { RequestParams } from "@stemscopes/api";
import { Params } from "@stemscopes/api/lib/hooks/use-query-params/duck/types";
import { GetBundlesFlags } from "./types";
import { SEGMENT_EDITIONS } from "./constants";

// prevent clicking twice on the same navigation link with dynamic setting of query params
export const linksClickHandlers: {
  [key: string]: (
    event: any,
    path?: string,
    params?: Params<RequestParams<any>>,
  ) => void;
} = {
  Assessments: (event, path, params) => {
    const { pathname } = window.location;

    if (pathname === path && !params?.type && params?.page?.number === 1) {
      event.preventDefault();
    }
  },
  Scopes: (event, path, params) => {
    const { pathname } = window.location;

    if (pathname === path && params?.page?.number === 1) {
      event.preventDefault();
    }
  },
  Help: (event) => {
    // TODO update hardcoded path 713 when /help route is fixed
    // prevent multiple redirects from '/help' to '/scopes/713'
    const { pathname } = window.location;

    if (pathname === "/scopes/713") {
      event.preventDefault();
    }
  },
};

export const getElementWidthByRef = (
  ref: React.RefObject<HTMLElement | null>,
): number => ref.current?.getBoundingClientRect().width || 0;

export const getBundlesFlags: GetBundlesFlags = (authData) => [
  !!authData.school.unitTopicIds?.length,
  !!authData.school.bundleTopicIds?.length,
  authData.school.editions.some((edition) =>
    SEGMENT_EDITIONS.includes(edition.shortName),
  ),
];
